import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMail, FiInfo } = FiIcons;

const ContactSection = ({ contactInfo }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.3 }}
      className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-purple-500/20"
    >
      <div className="flex items-center space-x-3 mb-6">
        <SafeIcon icon={FiPhone} className="text-2xl text-purple-400" />
        <h3 className="text-2xl font-bold text-white">📞 CONTACT INFORMATION</h3>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        <div className="bg-black/30 rounded-lg p-6 border border-purple-500/20">
          <div className="flex items-center space-x-3 mb-4">
            <SafeIcon icon={FiMail} className="text-lg text-blue-400" />
            <h4 className="text-lg font-semibold text-white">Emails</h4>
          </div>
          <div className="space-y-2">
            {contactInfo.emails.map((email, index) => (
              <div key={index} className="text-purple-300 text-sm">{email}</div>
            ))}
          </div>
        </div>
        <div className="bg-black/30 rounded-lg p-6 border border-purple-500/20">
          <div className="flex items-center space-x-3 mb-4">
            <SafeIcon icon={FiPhone} className="text-lg text-green-400" />
            <h4 className="text-lg font-semibold text-white">Phones</h4>
          </div>
          <div className="space-y-2">
            {contactInfo.phones.map((phone, index) => (
              <div key={index} className="text-purple-300 text-sm">{phone}</div>
            ))}
          </div>
        </div>
        <div className="bg-black/30 rounded-lg p-6 border border-purple-500/20">
          <div className="flex items-center space-x-3 mb-4">
            <SafeIcon icon={FiInfo} className="text-lg text-yellow-400" />
            <h4 className="text-lg font-semibold text-white">Other</h4>
          </div>
          <div className="space-y-2">
            {contactInfo.other.map((item, index) => (
              <div key={index} className="text-purple-300 text-sm">{item}</div>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ContactSection;